<template>

  <Dialog
    ref="Dialog"
    :title="this.scopedStrings.title"
    :width=300
  >

    <div class="save-body">
      <div class="choice-container">
        <div class="choice" v-for="(item, index) in items" :key="index">
          <input type="checkbox" :id="item.id" :value="item.id" v-model="saveItems">
          <label :for="item.id">{{ item.label }}</label>
        </div>
      </div>

      <button :disabled="emptySaveList" @click="saveAll">
        <i class="fa fa-save"></i>
        {{ this.scopedStrings.title }}
      </button>
    </div>

  </Dialog>

</template>

<script>
import Dialog from "@/components/Dialog";

export default {
  props: {
    scopedStrings: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      saveItems: []
    }
  },
  computed: {
    emptySaveList() {
      return this.saveItems.length == 0
    },
    items() {
      return [{
        id: "editor",
        label: this.scopedStrings.editor
      }, {
        id: "execution",
        label: this.scopedStrings.machineState
      }, {
        id: "instructionSet",
        label: this.scopedStrings.instructionSet
      }, {
        id: "hcl",
        label: this.scopedStrings.hcl
      }]
    }
  },
  components: {
    Dialog
  },
  methods: {
    show () {
      this.saveItems = [this.$parent.getCurrentTab().name]
      this.$refs.Dialog.show()
    },
    saveAll() {
      this.$parent.appSave(this.saveItems)
      this.$refs.Dialog.hide()
    }
  }
}

</script>

<style scoped>
.save-body {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.choice-container {
  display: flex;
  flex-direction: column;
  padding: 14px 0;
  width: fit-content;
}

.choice {
  font-size: 20px;
  padding: 6px;
}

.choice input[type="checkbox"] {
  display: none;
}

.choice input[type="checkbox"] + label:before {
  color: var(--SaveDialog-icon-foreground);
  content: "\f0c8";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  padding-right: 15px;
}

.choice input[type="checkbox"]:checked + label:before {
  color: var(--SaveDialog-icon-foreground);
  content: "\f14a";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  padding-right: 15px;
}

button {
  background-color: var(--SaveDialog-button-enabled-background);
  color: var(--SaveDialog-button-enabled-foreground);
  font-size: 30px;
  font-variant: small-caps;
  margin-bottom: 10px;
  padding: 3px 12px;
  transition-duration: .3s;
}

button:hover {
  background-color: var(--SaveDialog-button-hover-background);
}

button:disabled {
  background-color: var(--SaveDialog-button-disabled-background);
  color: var(--SaveDialog-button-disabled-foreground);
  cursor: not-allowed;
}
</style>